(() => {
  // recalled-reseller-pro v2 — sync membership + direct checkout
  const root = document.querySelector('[data-reseller-pro]');
  if (!root) return;

  const loggedIn = root.dataset.loggedIn === 'true';
  const email = (root.dataset.customerEmail || '').trim().toLowerCase();
  const partnerBase = (root.dataset.partnerBase || '').replace(/\/$/, '');
  const partnerSecret = root.dataset.partnerSecret || '';

  if (loggedIn && email && partnerBase && partnerSecret) {
    fetch(`${partnerBase}/api/customer/sync-membership`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Recalled-App-Secret': partnerSecret,
      },
      body: JSON.stringify({ email }),
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data) return;
        const liquidSaidPro = root.dataset.isPro === 'true';
        if (data.removedTag || Boolean(data.isPro) !== liquidSaidPro) {
          window.location.reload();
        }
      })
      .catch(() => {
        /* ignore */
      });
  }

  const checkoutBtn = root.querySelector('[data-membership-checkout]');
  if (!checkoutBtn) return;

  const variantId = root.dataset.variantId || '';
  const sellingPlanId = root.dataset.sellingPlanId || '';
  const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
  const cartClearUrl = root.dataset.cartClearUrl || '/cart/clear.js';
  const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
  const errorEl = root.querySelector('[data-membership-checkout-error]');

  const showError = (msg) => {
    if (!errorEl) return;
    errorEl.hidden = false;
    errorEl.textContent = msg;
  };

  checkoutBtn.addEventListener('click', async () => {
    if (!variantId) {
      showError('Mitgliedschafts-Produkt nicht gefunden.');
      return;
    }

    checkoutBtn.disabled = true;
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    try {
      // Empty cart first — only Reseller Pro in checkout
      await fetch(cartClearUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });

      const payload = {
        id: Number(variantId),
        quantity: 1,
      };
      if (sellingPlanId) {
        payload.selling_plan = Number(sellingPlanId);
      }

      const addRes = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!addRes.ok) {
        let message = 'Checkout konnte nicht gestartet werden.';
        try {
          const err = await addRes.json();
          message = err.description || err.message || message;
        } catch (_) {
          /* ignore */
        }
        throw new Error(message);
      }

      window.location.href = checkoutUrl;
    } catch (err) {
      checkoutBtn.disabled = false;
      showError(err && err.message ? err.message : 'Checkout fehlgeschlagen. Bitte erneut versuchen.');
    }
  });
})();
